<template>
    <!-- Content -->
    <section id="content" class="content terms-cont">
        <!-- Content Header -->
        <div class="content-header sub-visual">
            <div class="sub-visual-bg"></div>
            <div class="in-sec">
                <!-- 고도화 Ver1 : br추가 -->
                <div class="tit-wrap centered-c">
                    <h2 class="tit-h2">{{ $t('sdp.menu.ga.link') }}</h2>
                </div>
            </div>
        </div>
        <!-- //Content Header -->

        <!-- Content Body -->
        <div class="content-body">

            <div class="gaInfo">
                <h3>{{ $t('sdp.menu.ga.pop.message.001') }}</h3>
                <div class="gaTermsContent">
                    <ul>
                        <li v-html="$t('sdp.menu.ga.pop.message.003')"></li>
                        <li v-html="$t('sdp.menu.ga.pop.message.004')"></li>
                        <li v-html="$t('sdp.menu.ga.pop.message.005')"></li>
                        <li v-html="$t('sdp.menu.ga.pop.message.006')"></li>
                        <li v-html="$t('sdp.menu.ga.pop.message.007')"></li>
                        <li>{{ $t('sdp.menu.ga.pop.message.008') }}<br><span v-html="$t('sdp.menu.ga.pop.message.009')"></span></li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- //Content Body -->
    </section>
    <!-- //Content -->
</template>

<script>
    export default {
        name: "GA",
        data() {
            return {
                cntryCode: _domainCntryCode
            }
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>